import { capitalize, splitInTwo } from '#lib/overview/utils/string.js';

export type tagId = `tag:${string}` | `parameter:${string}`;
export type thresholdId = `threshold:${string}|${'<' | '<=' | '>=' | '>'}`;
export type id = tagId | thresholdId;
export type primitive = string | number | boolean;

export const toPrimitive = (x: unknown): primitive =>
  ['boolean', 'string', 'number'].includes(typeof x) ? (x as primitive) : String(x);

export const entryTitle = (id: id): string => {
  switch (id) {
    case 'parameter:datacenter':
      return 'Datacenter';
    case 'tag:any':
      return 'Tag';
    default: {
      const [type, rest] = splitInTwo(id, ':');
      if (type === 'threshold') {
        const [key, comp] = splitInTwo(rest, '|');
        return capitalize(key) + ' ' + comp;
      }
      return capitalize(rest);
    }
  }
};
